// jQuery(document).foundation();

var $ = jQuery.noConflict();



// Form7 - custom classes
jQuery('.wpcf7-submit').last().addClass('button');


// change header color on scroll
$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    //>=, not <=
    if (scroll >= 300) {
        //clearHeader, not clearheader - caps H
        $(".header.contrast-on-scroll").addClass("go_dark");
    } else {
        $(".header.contrast-on-scroll").removeClass("go_dark");
    }
});

// social share close off-canvas after click
$('.off-canvas .icon-share').on('click', function() {
    $('.off-canvas').foundation('close');
});



// ONEPAGE
// Remove part of the link in a href before #anchor - IF home
// ----------------
// $('body.home ul.main-nav li a').each(function(){
//   $(this).attr('href','#'+$(this).attr('href').split('#')[1]);
// });
// // remove current class for HOME
// $('body.home ul.main-nav li.current-menu-item').each(function(){
//   $(this).removeClass('current-menu-item');
//   $(this).removeClass('active');
// });

// close off-canvas after click
// $('.off-canvas a').on('click', function() {
//     $('.off-canvas').foundation('close');
// });





// SMOOTH SCROLL with offset
// issue with Foundation's accordion => remove # from a.accordion-title href
// ----------------
// var $=jQuery.noConflict();
// $('body').on('click','a[href^="#"]',function(event){
//     event.preventDefault();
//     var target_offset = $(this.hash).offset() ? $(this.hash).offset().top : 0;
//     var customoffset = 50;  //change this number to create the additional off set  
//     $('html, body').animate({scrollTop:target_offset - customoffset}, 1000);
// });